<template>
    <div class="row">
      <div class="col-sm">
        <div class="pd-y-20 pd-x-20 bg4 rounded-20">
            <div class="d-flex pd-l-20">
                <img src="/assets/img/sc.png" class="mx-wd-300" />
                <div class="mg-l-30">
                    <div class="mg-y-20 tx-20">Сайн уу, <b>{{$store.state.user.userInfo.fullName}}</b></div>
                    <div style="color: #002e46">
                        Докторын зэрэг хамгаалуулах зөвлөлийн сонгон шалгаруулалтын <br /> Вцахим системд тавтай морилно уу.
                    </div>
                    
                    <div @click="$router.push('/user/profile')" class="mg-t-20 tx-primary tx-semibold" role="button">
                        Хэрэглэгчийн мэдээлэл шинэчлэх бол <u class="pd-b-5">ЭНД</u> дарна уу
                    </div>
                </div>
            </div>    
        </div>
      </div>
    </div>
</template>
<script>
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

import { mapActions } from "vuex";

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Drawer } from "element-ui";

export default {
    props:{
      mustJoinCourses: {
        type: Object,
        default: () => {},
      },
    },
    data(){
        return{
            prjId: null,
            prjOt: null,
            taskModel: {
                task: ''
            },
        }
    },
    methods:{
    ...mapActions(["handleLoading"]),
      hasPerr(perrArr) {
        return hasOneOf(perrArr, this.$store.state.user.access);
      },
      reqPerr(){
        let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(567, 10)
        );

        if (prj.length > 0) {
        this.prjId = prj[0].id;
        this.prjOt = prj[0].objectTypeId;
        }

        this.handleLoading({ isLoading: true });
        request({
        api: { method: "POST", url: "taskCore/GetCoreList" },
        data: {
            skip: 0,
            size: 50,
            projectId: this.prjId,
        },
        store: this.$store,
        }).then((res) => {
            this.handleLoading({ isLoading: false });
            if (res != false) {
                if(res.data.allCount>0){
                    Notification.warning({
                        title: "Мэдэгдэл",
                        message: `Өмнө хүсэлт илгээсэн байна. Холбогдох мэргэжилтэнд хандана уу`,
                        duration: 5000,
                        position: "bottom-right",
                    });
                }else{
                    this.reqPost();
                }
            }
        });
      },
      reqPost(){
        this.handleLoading({ isLoading: true });
        request({
            api: { method: "GET", url: "Task/GetInherited" },
            params: {
            id: 0,
            objectTypeId: this.prjOt,
            parentId: 0,
            projectId: this.prjId,
            boxId: 0,
            userId: this.$store.state.user.userInfo.userId,
            },
            store: this.$store,
        }).then((res) => {
            this.handleLoading({ isLoading: false });
            if (res != false) {
            this.taskModel= res.data.task;
            this.taskModel.task= this.$store.state.user.userInfo.fullName;
            this.handleLoading({ isLoading: true });
            request({
                api: { method: "POST", url: "Task/PostInherited" },
                data: { model: this.taskModel },
                store: this.$store,
            }).then((ress) => {
                this.handleLoading({ isLoading: false });
                if (ress != false) {
                    Notification.info({
                        title: "Мэдэгдэл",
                        message: `Шинжээчээр ажиллах хүсэлтийг хүлээн авлаа`,
                        duration: 5000,
                        position: "bottom-right",
                    });
                }
            });
            }
        });
      },
    }
}
</script>
<style scoped lang="less">
.bg4{
    position: relative;
    background: rgba(212, 244, 252, 1);
    overflow: hidden;
    &::before{
        content: '';
        background: #c3edfc;
        width: 120px;
        height: 120px;
        position: absolute;
        left: -40px;
        top: -60px;
        border-radius: 50%;
    }
    &::after{
        content: '';
        background: #c3edfc;
        width: 120px;
        height: 120px;
        position: absolute;
        right: -40px;
        bottom: -60px;
        border-radius: 50%;
    }
}
</style>